module.exports = __webpack_public_path__ + "img/2_4.e7a008a1.png";